// extracted by mini-css-extract-plugin
export default {"body":"Modal_body__QBuaA","backdrop":"Modal_backdrop__sVPQZ"};